import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  getDocs,
  connectFirestoreEmulator
} from "firebase/firestore";
import {
  getFunctions,
  httpsCallable,
  connectFunctionsEmulator
} from "firebase/functions";
import fbConfig from "../fb.json"; // Firebase config

const app = initializeApp(fbConfig);
const db = getFirestore(app);
const functions = getFunctions(app);

if (
  window.location.hostname === "localhost" ||
  window.location.protocol === "file:"
) {
  connectFunctionsEmulator(functions, "localhost", 5001);
}

// 🔹 Function to Get All Sources
export const getSources = async () => {
  try {
    const sourcesCollection = collection(db, "sources");
    const sourcesSnapshot = await getDocs(sourcesCollection);

    const sources = sourcesSnapshot.docs.map((doc) => ({
      id: doc.id // Source ID
    }));

    console.log("Fetched sources:", sources);
    return sources; // Example: [{ id: "stripe" }, { id: "paypal" }]
  } catch (error) {
    console.error("Error fetching sources:", error.message);
    return [];
  }
};

// 🔹 Function to Call Emulator Cloud Function for Subcollections
export const getSubcollectionsForSource = async (sourceId) => {
  const listSubcollections = httpsCallable(
    functions,
    "list_subcollections_for_source"
  );

  try {
    const response = await listSubcollections({ sourceId });
    console.log(`Fetched subcollections for ${sourceId}:`, response.data);
    return response.data;
  } catch (error) {
    console.error("Error calling Cloud Function:", error.message);
    return {};
  }
};

export { db };
